import { useState } from "react"
import "./styles.css"
import "../../fonts.css"
import { IoIosSearch } from "react-icons/io"
import Mock from "./Mock"
import Info from "./Info"
import Loader from "../../components/Loader"
import { BiErrorCircle } from "react-icons/bi"
import useBooks from "../../utils/mocks/books/useBooks"
import Layout from "../../components/Layout"

const Livros = () => {
  const { data: data, loading: loading, error } = useBooks()
  const [search, setSearch] = useState("")

  return (
    <Layout
      title="Livros"
      titleColor="#6184FE"
      description=""
      hasBackground={false}
      children={
        <div className="container">
          <div className="search-container">
            <input
              placeholder="Busca"
              type="text"
              className="search-field"
              onChange={(event) => setSearch(event.target.value)}
            />
            <IoIosSearch color="rgba(0, 0, 0, 0.8)" />
          </div>
          <div className="containerLivros">
            {loading ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <Loader size={40} />
              </div>
            ) : data ? (
              data
                .filter((localData) => {
                  return search.toLocaleLowerCase() === ""
                    ? localData
                    : localData.title
                        .toLocaleLowerCase()
                        .includes(search.toLocaleLowerCase())
                })
                .map((localData) => {
                  return (
                    <Info
                      key={localData.id}
                      title={localData.title}
                      address={localData.author_name}
                      imagemURL={localData.image_link}
                      buyLink={localData.buy_link}
                    />
                  )
                })
            ) : null}
            {error ? (
              <div className="item-error-livros">
                <BiErrorCircle /> Houve um erro ao processar sua solicitação.
              </div>
            ) : null}
          </div>
        </div>
      }
      backButton="/sugestoes"
    />
  )
}

export default Livros
